import '../src/cassis-reader.css';
import {setup, start} from './cassis/cassis-reader';

function getCassisOptions(viewerElement, webpubManifestUrl, webAssetsUrl, locale) {
    const optionsElement = document.getElementById("viewer-start");

    if (optionsElement === undefined){
        return {}
    }

    const startOptions = JSON.parse(optionsElement.dataset.options);

    const tracker = {
        prefix: "cassis-tracker",
        post_url: null, // TODO
        epub_id: null, // TODO
        heartbeat_rate: 10,
        reader_type: null,
        version: "1.0"
    };

    Object.assign(tracker, startOptions.tracker)

    const bookInfo = {
        title: "",
        publisher: "",
        buy_link: null,
        buy_link_nav: null,
        buy_links: null,
        share_link: null
    };

    Object.assign(bookInfo, startOptions.bookInfo)

    const tosLink = {
        url: new URL(startOptions.tosLink.url),
        label: startOptions.tosLink.label
    };

    const annotationEndpoints = {
        bookmarks: null,
        lastReadingPosition: null
    }
    Object.assign(annotationEndpoints, startOptions.annotationEndpoints);

    const rendition = startOptions.rendition || "reflow";
    let libHandler = null;

    const embedded = startOptions.embedded

    if (!embedded) {
        if (startOptions.hasOwnProperty('libHandler') && startOptions.libHandler !== null) {
            libHandler = {
                in_bookshelf: null,
                my_books_route: null,
                streamer_identifier: "",
                redirect_url: null
            };

            Object.assign(libHandler, startOptions.libHandler);
        }
    }

    const lastReadingPosition = null; // TODO
    const startPath = startOptions.startPath;
    const loggedIn = startOptions.loggedIn;

    let upLink = null;
    if (startOptions.hasOwnProperty('upLink')) {
        upLink = {
            url: new URL(startOptions.upLink.url),
            label: startOptions.upLink.label,
            ariaLabel: startOptions.upLink.ariaLabel
        }
    }

    // TODO: accept it as an option rather than making it globally all fxl
    const preventContextMenu = (rendition === 'fxl');

    const cassisOptions = {
        annotationEndpoints: annotationEndpoints,
        bookInfo: bookInfo,
        bookPlateHintStart: 1000*120, // 2 minutes
        libHandler: libHandler,
        tosLink: tosLink,
        tracker: tracker,
        assetsUrl: webAssetsUrl,
        element: viewerElement,
        embedded: embedded,
        jbksBookplate: "jellybooks_data.xhtml",
        lastReadingPosition: lastReadingPosition,
        locale: locale,
        loggedIn: loggedIn,
        rendition: rendition,
        manifestUrl: webpubManifestUrl,
        mode: startOptions.mode,
        noBookplate: false,
        retailers: null,
        upLink: upLink,
        preventContextMenu: preventContextMenu,
        enableLocaleSwitcher: true,
        enableGuide: true
    }
    if (startPath) {
        cassisOptions.startPath = startPath
    }
    if (startOptions.hasOwnProperty('manifest_expiry')) {
        cassisOptions.manifest_expiry = startOptions.manifest_expiry
    }
    if (startOptions.hasOwnProperty('autoHideToolbar') && startOptions.autoHideToolbar !== null) {
        cassisOptions.autoHideToolbar = startOptions.autoHideToolbar;
    }

    return cassisOptions;
}

function launchReader(viewerElement, manifestUrl, assetsUrl, locale) {
    const webpubManifestUrl = new URL(manifestUrl);
    const webAssetsUrl = new URL(assetsUrl || webpubManifestUrl.href);
    const options = getCassisOptions(viewerElement, webpubManifestUrl, webAssetsUrl, locale);
    start(options);
}


document.addEventListener('DOMContentLoaded', (event) => {
    const viewerElement = document.getElementById("viewer");
    const manifestSrc = viewerElement.dataset.manifestSrc;

    if (manifestSrc !== undefined) {
        const locale = document.documentElement.getAttribute("lang");
        const assetsSrc = viewerElement.dataset.assetsSrc;

        const getCsrfToken = function() {
            const token = document.head.querySelector("meta[name=csrf-token]");
            return token ? token.content : undefined;
        };

        let associateUrl = viewerElement.dataset.associateUrl;
        if (associateUrl !== undefined) {
            associateUrl += window.location.search;

            document.addEventListener("trackerLoaded", function(event) {
                fetch(associateUrl, {
                    body: JSON.stringify({session: event.detail.deviceId}),
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": getCsrfToken()
                    },
                    method: "POST"
                }).catch(function(error) {
                    console.error("There has been a problem with your fetch operation: ", error.message);
                });
            });
        }

        const statusUrl = viewerElement.dataset.statusUrl;
        if (statusUrl) {
            document.addEventListener("trackerUpdate", function (event) {
                fetch(statusUrl, {
                    body: JSON.stringify({session: event.detail.deviceId, status: event.detail.dataCollection}),
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": getCsrfToken()
                    },
                    method: "POST"
                }).catch(function (error) {
                    console.error("There has been a problem with your fetch operation: ", error.message);
                });
            });
        }

        const setupUrl = viewerElement.dataset.setupUrl;
        if (setupUrl) {
            setup().then(function (data) {
                fetch(setupUrl, {
                    body: JSON.stringify({session_id: data.session_id}),
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": getCsrfToken()
                    },
                    method: "POST"
                }).then(function () {
                    if (manifestSrc) {
                        launchReader(viewerElement, manifestSrc, assetsSrc, locale);
                    }
                }).catch(function (err) {
                    console.error(err);
                });

            }).catch(function (err) {
                console.error(err)
            });
        } else {
            launchReader(viewerElement, manifestSrc, assetsSrc, locale);    
        }

    }
});
